import {hasSomePermission} from '../../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../Permissions';

/**
 * Whether a work-detail snapshot built by THIS viewer may carry rate and value.
 *
 * Two conditions, and both are load-bearing:
 *
 * 1. The company opted in to rate disclosure. This is the product decision — it puts hourly rates on
 *    a document handed to a client.
 * 2. The viewer can actually see revenue. `TimeReg.price` is only populated inside the backend's
 *    `VIEW_FINANCIAL_INFORMATION` / `..._REVENUE` gate and is set to `0.0` otherwise, so a creator
 *    without that access reads every registration as costing nothing. The snapshot is immutable once
 *    saved, so without this check such a creator bakes `0.00` rate and value onto a client-facing
 *    invoice — numbers that look deliberate and are simply the absence of permission.
 *
 * Failing this leaves `rate` and `value` null, which every renderer already prints as an em dash
 * meaning "not recorded". Withholding the amounts is recoverable; a wrong amount on a sent invoice is
 * not.
 */
export const canSnapshotWorkDetailRates = (company: {workDetailShowRates?: boolean | null} | null | undefined): boolean =>
	!!company?.workDetailShowRates &&
	hasSomePermission([PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION, PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE]);
